import React from "react";
import type { Team } from "../types/team";
interface RevealedListProps {
  teams: Team[];
  tone?: "light" | "dark";
}
export function RevealedList({
  teams,
  tone = "light"
}: RevealedListProps) {
  const dark = tone === "dark";
  return <ol className={`divide-y border-y ${dark ? "divide-white/10 border-white/10" : "divide-line border-line"}`} aria-live="polite" data-id="element-310" data-mp="di21r33j2pua">
      {teams.map(t => <li key={t.id} className="flex flex-wrap items-baseline gap-x-4 gap-y-1 py-3" data-id="element-311" data-mp="1654x5mcwqkgb">
          <span className="w-16 shrink-0 text-sm font-semibold" data-id="element-312" data-mp="118ehv18xfsvy">Team {t.id}</span>
          <span className="flex min-w-0 flex-1 flex-wrap gap-x-4 gap-y-1" data-id="element-313" data-mp="w7qrmhsivg2s">
            {t.members.map(m => <span key={m.name} className="inline-flex items-center gap-1.5 text-[15px]" data-id="element-314" data-mp="s7geml6bbpef">
                <span className={`h-2 w-2 rounded-full ${m.school === "link" ? "bg-brgreen" : "bg-saffron"}`} aria-hidden="true" data-id="element-315" data-mp="3gyra8umo89ml" />
                {m.name}
              </span>)}
          </span>
          {t.members.length === 3 && <span className={`text-xs ${dark ? "text-white/60" : "text-muted"}`} data-id="element-316" data-mp="3lq8gn89ml8yp">Trio</span>}
        </li>)}
    </ol>;
}